import { Box, Typography, Grid, Paper, Alert } from '@mui/material'
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing'
import FilterPanel from '../../components/FilterPanel'
import UserSavingsTable from '../../components/charts/UserSavingsTable'
import ManufacturerBreakdown from '../../components/charts/ManufacturerBreakdown'
import { useFilters } from '../../context/FilterContext'
import { DataQualityBanner } from '../../components/ui/DataQualityContext'

function EquipmentAnalysis() {
  const { filteredData, activeFilterCount } = useFilters()

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <PrecisionManufacturingIcon sx={{ fontSize: 32, color: 'primary.main' }} />
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Equipment Analysis
          </Typography>
          <Typography variant="body2" color="text.secondary">
            User-configurable savings calculator and manufacturer performance breakdown
          </Typography>
        </Box>
      </Box>

      <Box sx={{ mb: 3 }}>
        <FilterPanel compact />
      </Box>
      <Box sx={{ mb: 3 }}>
        <DataQualityBanner compact />
      </Box>

      {activeFilterCount > 0 && (
        <Alert severity="info" sx={{ mb: 3 }}>
          Showing analysis for {filteredData.length} filtered studies.
        </Alert>
      )}

      <Grid container spacing={3}>
        {/* User Savings Table */}
        <Grid item xs={12}>
          <Paper sx={{ p: { xs: 1.5, sm: 2 }, overflow: 'auto' }}>
            <UserSavingsTable />
          </Paper>
        </Grid>

        {/* Manufacturer Breakdown */}
        <Grid item xs={12}>
          <Paper sx={{ p: { xs: 1.5, sm: 2 }, overflow: 'auto' }}>
            <ManufacturerBreakdown />
          </Paper>
        </Grid>
      </Grid>

      {/* Info Note */}
      <Alert severity="info" icon={false} sx={{ mt: 4 }}>
        <Typography variant="subtitle2" gutterBottom>
          Equipment Performance Notes
        </Typography>
        <Typography variant="body2">
          Performance varies by equipment type, age, and operating conditions.
          All measurements are PE-certified field measurements conducted under ASHRAE testing protocols.
          Manufacturer data is aggregated from the corpus of case studies.
        </Typography>
      </Alert>
    </Box>
  )
}

export default EquipmentAnalysis
